import Ad from '@/entities/Ad.js';
import AdMetric from '@/entities/AdMetric.js';
import api from '@/services/Api';

export default {
  get(id) {
    return api().get('/ad/' + id)
      .then(resp => new Ad(resp));
  },

  // Returns { period, metric } where metric is an AdMetric instance or null.
  // The backend persists metrics only for 8ad-managed ads, so `metric` may be
  // null even for a valid ad — the caller renders a "no data" state in that case.
  getMetrics(id, period) {
    const data = {};
    if (period) {
      data['period'] = period;
    }

    const query = new URLSearchParams(data).toString();
    const queryString = query ? '?' + query : '';

    return api().get('/ad/' + id + '/metrics' + queryString)
      .then(resp => ({
        period: resp.period,
        metric: resp.metric ? new AdMetric(resp.metric) : null,
      }));
  },

  update(id, { text }) {
    return api().put('/ad/' + id, { text })
      .then(resp => new Ad(resp));
  },

  updateStatus(id, active) {
    return api().put('/ad/' + id + '/status', { active })
      .then(resp => new Ad(resp));
  },
};
